(function () {
  var INTERVAL = 2000;
  var BREAKPOINT = 990;

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var medias = Array.from(document.querySelectorAll('.card-wrapper .media.media--hover-effect')).filter(function (media) {
      return media.querySelectorAll(':scope > img').length > 1;
    });
    if (!medias.length) return;

    setInterval(function () {
      if (window.innerWidth >= BREAKPOINT) return;
      medias.forEach(function (media) {
        media.classList.toggle('lushe-card-cycle-show-2nd');
      });
    }, INTERVAL);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
